import NP from 'number-precision'

export function clientDefaultDiscountForItem(client) {
    const discountType = Number(client.itemDiscountAsPercent) === 1 ? 1 : 0;
    const storedDiscount = Number(client.itemDiscount);
    const discount = Number.isFinite(storedDiscount) && storedDiscount >= 0 ? storedDiscount : 0;

    return {
        type: discountType,
        value: discountType === 1 ? NP.times(discount, 100) : discount
    };
}

export function storedDiscountForEditor(discount, discountAsPercent) {
    const discountType = Number(discountAsPercent) === 1 ? 1 : 0;
    const storedDiscount = Number(discount);
    const normalizedDiscount = Number.isFinite(storedDiscount) && storedDiscount >= 0 ? storedDiscount : 0;
    return discountType === 1 ? NP.times(normalizedDiscount, 100) : normalizedDiscount;
}
